export const CategoryQueryKeys = {
  all: () => ["categories"],
  single: (categoryId: string | undefined) => [...CategoryQueryKeys.all(), categoryId],
};

export const PartQueryKeys = {
  all: (hideCategorised: boolean, hideAccepted: boolean) => ["parts", hideCategorised.toString(), hideAccepted.toString()],
  single: (categoryId: string | undefined) => [...CategoryQueryKeys.all(), categoryId],
};

export const CategorySearchTermQueryKeys = {
  all: () => ["categorySearchTerms"],
  single: (categorySearchTermId: string | undefined) => [...CategorySearchTermQueryKeys.all(), categorySearchTermId],
};